import { BinIcon, Button } from "@jutro/ui";
import { Dispatch, SetStateAction, useState } from "react";
import { ConfirmDialog } from "components/new/ConfirmDialog";
import {
  DoctorGetDocumentsDocument,
  DoctorMSMedicalRecordEntity,
  useDoctorArchiveDocumentMutation,
} from "lib/graphql/megaSchema";
import { toaster } from "lib/tools/toaster";

export type ActionButtonProps = {
  rows: DoctorMSMedicalRecordEntity[];
  setSelectedRows?: Dispatch<SetStateAction<DoctorMSMedicalRecordEntity[]>>;
  multiple?: boolean;
};

export const ActionButton = ({
  rows,
  setSelectedRows,
  multiple = false,
}: ActionButtonProps) => {
  const [deleteDocumentOpen, setDeleteDocumentOpen] = useState(false);
  const [archiveDocument] = useDoctorArchiveDocumentMutation({
    refetchQueries: [DoctorGetDocumentsDocument],
    awaitRefetchQueries: true,
  });

  const removeFile = async (document: DoctorMSMedicalRecordEntity) => {
    return await archiveDocument({
      variables: {
        id: document.id,
      },
    });
  };

  return (
    <>
      <Button
        full={false}
        variant="secondaryNegative"
        icon={<BinIcon />}
        label="Usuń"
        size="condensed"
        tooltipPosition="top"
        onClick={(e) => {
          e.stopPropagation();
          setDeleteDocumentOpen(true);
        }}
        {...(multiple ? { text: "Usuń" } : {})}
      />

      <ConfirmDialog
        title={
          rows.length > 1
            ? "Czy chcesz usunąć dokumenty?"
            : "Czy chcesz usunąć dokument?"
        }
        text={
          rows.length > 1
            ? `<div style="height:8px"></div>${rows
                .map((f) => "• " + (f.tidyDocumentationResult?.name ?? f.name))
                .join(`<div style="height:12px"></div>`)}`
            : `<div style="height:8px"></div>${rows[0]?.tidyDocumentationResult?.name ?? rows[0]?.name}`
        }
        open={deleteDocumentOpen}
        setOpen={setDeleteDocumentOpen}
        onConfirm={() => {
          for (const file of rows) {
            removeFile(file)
              .then(() =>
                toaster.notify(
                  rows.length > 1
                    ? "Dokumenty zostały usunięte"
                    : "Dokument został usunięty",
                  { duration: 20000, id: "remove-medical-record" },
                ),
              )
              .catch(() =>
                toaster.warning(
                  rows.length > 1
                    ? "Nie udało się usunąć dokumentów"
                    : "Nie udało się usunąć dokumentu",
                ),
              );
          }

          if (setSelectedRows) {
            setSelectedRows([]);
          }
        }}
      />
    </>
  );
};
